const TYPE_ALIASES = {
  agent_message: "agentMessage",
  collab_agent_tool_call: "collabAgentToolCall",
  command_execution: "commandExecution",
  context_compaction: "contextCompaction",
  dynamic_tool_call: "dynamicToolCall",
  file_change: "fileChange",
  hook_prompt: "hookPrompt",
  image_generation: "imageGeneration",
  image_view: "imageView",
  mcp_tool_call: "mcpToolCall",
  sub_agent_activity: "subAgentActivity",
  todo_list: "todoList",
  user_message: "userMessage",
  web_search: "webSearch"
};

const EVENT_TYPE_ALIASES = {
  "agent.message.delta": "item/agentMessage/delta",
  "codex.agent.message.delta": "item/agentMessage/delta",
  "codex.account.login.completed": "account/login/completed",
  "codex.configWarning": "configWarning",
  "codex.command.exec.outputDelta": "command/exec/outputDelta",
  "codex.error": "error",
  "codex.externalAgentConfig.import.completed": "externalAgentConfig/import/completed",
  "codex.externalAgentConfig.import.progress": "externalAgentConfig/import/progress",
  "codex.fuzzyFileSearch.sessionCompleted": "fuzzyFileSearch/sessionCompleted",
  "codex.fuzzyFileSearch.sessionUpdated": "fuzzyFileSearch/sessionUpdated",
  "codex.hook.completed": "hook/completed",
  "codex.hook.started": "hook/started",
  "codex.item.agentMessage.delta": "item/agentMessage/delta",
  "codex.item.autoApprovalReview.completed": "item/autoApprovalReview/completed",
  "codex.item.autoApprovalReview.started": "item/autoApprovalReview/started",
  "codex.item.commandExecution.outputDelta": "item/commandExecution/outputDelta",
  "codex.item.commandExecution.terminalInteraction": "item/commandExecution/terminalInteraction",
  "codex.item.completed": "item/completed",
  "codex.item.fileChange.outputDelta": "item/fileChange/outputDelta",
  "codex.item.fileChange.patchUpdated": "item/fileChange/patchUpdated",
  "codex.item.mcpToolCall.progress": "item/mcpToolCall/progress",
  "codex.item.plan.delta": "item/plan/delta",
  "codex.item.reasoning.summaryPartAdded": "item/reasoning/summaryPartAdded",
  "codex.item.reasoning.summaryTextDelta": "item/reasoning/summaryTextDelta",
  "codex.item.reasoning.textDelta": "item/reasoning/textDelta",
  "codex.item.started": "item/started",
  "codex.item.updated": "item/updated",
  "codex.mcpServer.oauthLogin.completed": "mcpServer/oauthLogin/completed",
  "codex.mcpServer.startupStatus.updated": "mcpServer/startupStatus/updated",
  "codex.model.rerouted": "model/rerouted",
  "codex.model.safetyBuffering.updated": "model/safetyBuffering/updated",
  "codex.model.verification": "model/verification",
  "codex.process.exited": "process/exited",
  "codex.process.outputDelta": "process/outputDelta",
  "codex.remoteControl.status.changed": "remoteControl/status/changed",
  "codex.serverRequest.resolved": "serverRequest/resolved",
  "codex.skills.changed": "skills/changed",
  "codex.thread.archived": "thread/archived",
  "codex.thread.compacted": "thread/compacted",
  "codex.thread.closed": "thread/closed",
  "codex.thread.deleted": "thread/deleted",
  "codex.thread.goal.cleared": "thread/goal/cleared",
  "codex.thread.goal.updated": "thread/goal/updated",
  "codex.thread.realtime.closed": "thread/realtime/closed",
  "codex.thread.realtime.error": "thread/realtime/error",
  "codex.thread.realtime.itemAdded": "thread/realtime/itemAdded",
  "codex.thread.realtime.outputAudio.delta": "thread/realtime/outputAudio/delta",
  "codex.thread.realtime.sdp": "thread/realtime/sdp",
  "codex.thread.realtime.started": "thread/realtime/started",
  "codex.thread.realtime.transcript.delta": "thread/realtime/transcript/delta",
  "codex.thread.realtime.transcript.done": "thread/realtime/transcript/done",
  "codex.thread.started": "thread/started",
  "codex.thread.status.changed": "thread/status/changed",
  "codex.thread.unarchived": "thread/unarchived",
  "codex.turn.diff.updated": "turn/diff/updated",
  "codex.turn.started": "turn/started",
  "codex.turn.plan.updated": "turn/plan/updated",
  "codex.warning": "warning",
  "codex.windows.worldWritableWarning": "windows/worldWritableWarning",
  "codex.windowsSandbox.setupCompleted": "windowsSandbox/setupCompleted",
  "account.login.completed": "account/login/completed",
  "command.exec.outputDelta": "command/exec/outputDelta",
  "externalAgentConfig.import.completed": "externalAgentConfig/import/completed",
  "externalAgentConfig.import.progress": "externalAgentConfig/import/progress",
  "fuzzyFileSearch.sessionCompleted": "fuzzyFileSearch/sessionCompleted",
  "fuzzyFileSearch.sessionUpdated": "fuzzyFileSearch/sessionUpdated",
  "hook.completed": "hook/completed",
  "hook.started": "hook/started",
  "item.commandExecution.outputDelta": "item/commandExecution/outputDelta",
  "item.commandExecution.terminalInteraction": "item/commandExecution/terminalInteraction",
  "item.completed": "item/completed",
  "item.started": "item/started",
  "item.updated": "item/updated",
  "mcpServer.oauthLogin.completed": "mcpServer/oauthLogin/completed",
  "model.rerouted": "model/rerouted",
  "model.safetyBuffering.updated": "model/safetyBuffering/updated",
  "model.verification": "model/verification",
  "process.exited": "process/exited",
  "process.outputDelta": "process/outputDelta",
  "skills.changed": "skills/changed",
  "thread.archived": "thread/archived",
  "thread.compacted": "thread/compacted",
  "thread.closed": "thread/closed",
  "thread.deleted": "thread/deleted",
  "thread.goal.cleared": "thread/goal/cleared",
  "thread.goal.updated": "thread/goal/updated",
  "thread.realtime.closed": "thread/realtime/closed",
  "thread.realtime.error": "thread/realtime/error",
  "thread.realtime.itemAdded": "thread/realtime/itemAdded",
  "thread.realtime.outputAudio.delta": "thread/realtime/outputAudio/delta",
  "thread.realtime.sdp": "thread/realtime/sdp",
  "thread.realtime.started": "thread/realtime/started",
  "thread.realtime.transcript.delta": "thread/realtime/transcript/delta",
  "thread.realtime.transcript.done": "thread/realtime/transcript/done",
  "thread.started": "thread/started",
  "thread.status.changed": "thread/status/changed",
  "thread.tokenUsage.updated": "thread/tokenUsage/updated",
  "thread.unarchived": "thread/unarchived",
  "turn.completed": "turn/completed",
  "turn.diff.updated": "turn/diff/updated",
  "turn.failed": "turn/failed",
  "turn.plan.updated": "turn/plan/updated",
  "turn.started": "turn/started",
  "usage.updated": "usage/updated",
  "windows.worldWritableWarning": "windows/worldWritableWarning",
  "windowsSandbox.setupCompleted": "windowsSandbox/setupCompleted"
};

const SYSTEM_EVENT_TYPES = new Set([
  "account/rateLimits/updated",
  "account/updated",
  "app/list/updated",
  "configWarning",
  "conversation.title.updated",
  "deprecationNotice",
  "externalAgentConfig/import/progress",
  "fuzzyFileSearch/sessionCompleted",
  "fuzzyFileSearch/sessionUpdated",
  "fs/changed",
  "guardianWarning",
  "mcpServer/startupStatus/updated",
  "model/safetyBuffering/updated",
  "rawResponseItem/completed",
  "remoteControl/status/changed",
  "serverRequest/resolved",
  "skills/changed",
  "thread/archived",
  "thread/closed",
  "thread/deleted",
  "thread/goal/cleared",
  "thread/name/updated",
  "thread/realtime/closed",
  "thread/realtime/error",
  "thread/realtime/itemAdded",
  "thread/realtime/outputAudio/delta",
  "thread/realtime/sdp",
  "thread/realtime/started",
  "thread/realtime/transcript/delta",
  "thread/realtime/transcript/done",
  "thread/settings/updated",
  "thread/started",
  "thread/status/changed",
  "thread/tokenUsage/updated",
  "thread/unarchived",
  "turn/moderationMetadata",
  "turn/started",
  "usage/updated",
  "warning"
]);

const RUN_STATUS_NOTICES = {
  interrupted: {
    icon: "pause_circle",
    text: "运行已中断，当前输出已保留，可以继续这次会话。"
  },
  needs_resume: {
    icon: "replay_circle_filled",
    text: "Codex 需要继续运行，当前输出已保留，可以从这里恢复。"
  },
  host_unavailable: {
    icon: "cloud_off",
    text: "Mac 监听端暂时不可用，当前输出已保留，等待监听端恢复后可继续。"
  },
  reconciling: {
    icon: "sync_problem",
    text: "正在同步 Mac 上的运行状态，当前输出已保留。"
  },
  cancelled: {
    icon: "cancel",
    text: "运行已取消，当前输出已保留。"
  },
  expired: {
    icon: "schedule",
    text: "运行已过期，当前输出已保留，可以重新继续。"
  }
};

export function buildCodexTranscript(details, options = {}) {
  const terminalStatuses = options.terminalStatuses ?? new Set();
  const resumedRunIds = new Set(details
    .map((detail) => detail.run?.parentRunId)
    .filter(Boolean));
  return details.flatMap((detail) => buildRunTranscript(detail, terminalStatuses, {
    hideStatusNotice: resumedRunIds.has(detail.run?.runId)
  }));
}

function buildRunTranscript(detail, terminalStatuses, options = {}) {
  const run = detail.run ?? {};
  const runId = run.runId ?? cryptoRandomFallback();
  const live = Boolean(run.status && !terminalStatuses.has(run.status));
  const ordered = [...(detail.events ?? [])].sort((a, b) => Number(a.seq ?? 0) - Number(b.seq ?? 0));
  const state = {
    run,
    runId,
    live,
    items: [],
    byId: new Map(),
    approvalIds: new Set(),
    assistantDeltaId: `${runId}:assistant-stream`,
    commandDeltaIds: new Map(),
    reasoningDeltaIds: new Map(),
    activeAssistantItemId: null,
    activeCommandItemId: null,
    activeReasoningItemId: null,
    planId: `${runId}:plan`,
    diffId: `${runId}:diff`
  };

  for (const event of ordered) {
    applyEvent(state, event);
  }

  ensureOptimisticUserMessage(state, detail);
  ensureFallbackAssistantMessage(state, detail);
  appendRunArtifacts(state, detail.manifest?.artifacts ?? detail.final?.artifacts ?? []);
  appendApprovals(state, detail.approvals ?? []);
  appendRunError(state, run, ordered);
  if (!options.hideStatusNotice) appendRunStatusNotice(state, run);

  return state.items.filter((item) => item.visible !== false);
}

function applyEvent(state, event) {
  const type = normalizeEventType(event?.type);
  const payload = event?.payload ?? {};
  if (!type || SYSTEM_EVENT_TYPES.has(type)) {
    return;
  }

  if (isItemStarted(type)) {
    const item = upsertThreadItem(state, payload.item, {
      runId: state.runId,
      eventType: type,
      statusHint: "in_progress",
      streaming: state.live,
      attachments: itemAttachments(payload.item)
    });
    setActiveDeltaTarget(state, item);
    return;
  }

  if (isItemCompleted(type)) {
    const item = upsertThreadItem(state, payload.item, {
      runId: state.runId,
      eventType: type,
      statusHint: terminalStatus(payload.item),
      streaming: false,
      attachments: itemAttachments(payload.item)
    });
    clearActiveDeltaTarget(state, item);
    return;
  }

  if (type === "item/updated") {
    applyItemUpdate(state, payload);
    return;
  }

  if (type === "thread/compacted") {
    upsertContextCompactionNotice(state, payload);
    return;
  }

  if (type === "thread/goal/updated") {
    upsertThreadGoalNotice(state, payload);
    return;
  }

  if (type === "model/rerouted") {
    upsertModelRerouteNotice(state, payload);
    return;
  }

  if (type === "model/verification") {
    upsertModelVerificationNotice(state, payload);
    return;
  }

  if (type === "account/login/completed") {
    upsertAccountLoginNotice(state, payload);
    return;
  }

  if (type === "hook/started") {
    upsertHookRun(state, payload, "running");
    return;
  }

  if (type === "hook/completed") {
    upsertHookRun(state, payload, payload.run?.status ?? "completed");
    return;
  }

  if (type === "mcpServer/oauthLogin/completed") {
    upsertMcpOauthNotice(state, payload);
    return;
  }

  if (type === "externalAgentConfig/import/completed") {
    upsertNotice(state, {
      id: `${state.runId}:external-agent-config-imported`,
      icon: "settings_applications",
      text: "外部代理配置已导入。"
    });
    return;
  }

  if (type === "windows/worldWritableWarning") {
    upsertWindowsWorldWritableWarning(state, payload);
    return;
  }

  if (type === "windowsSandbox/setupCompleted") {
    upsertWindowsSandboxSetupNotice(state, payload);
    return;
  }

  if (type === "item/autoApprovalReview/started") {
    upsertAutoApprovalReview(state, payload, "inProgress");
    return;
  }

  if (type === "item/autoApprovalReview/completed") {
    upsertAutoApprovalReview(state, payload, payload.review?.status ?? "completed");
    return;
  }

  if (type === "item/agentMessage/delta") {
    appendAssistantDelta(state, payload.delta ?? payload.text ?? "", payload.itemId);
    return;
  }

  if (type === "item/plan/delta") {
    appendPlanDelta(state, payload);
    return;
  }

  if (type === "item/reasoning/summaryTextDelta" || type === "item/reasoning/summaryPartAdded") {
    appendReasoningDelta(state, payload.delta ?? payload.text ?? "", payload.itemId, "summary");
    return;
  }

  if (type === "item/reasoning/textDelta") {
    appendReasoningDelta(state, payload.delta ?? payload.text ?? "", payload.itemId, "content");
    return;
  }

  if (type === "item/commandExecution/outputDelta") {
    appendCommandDelta(state, payload.delta ?? "", payload.itemId);
    return;
  }

  if (type === "item/commandExecution/terminalInteraction") {
    appendCommandTerminalInteraction(state, payload);
    return;
  }

  if (type === "command/exec/outputDelta") {
    appendProcessOutputDelta(state, payload, {
      idPrefix: "command-exec",
      command: "命令执行"
    });
    return;
  }

  if (type === "process/outputDelta") {
    appendProcessOutputDelta(state, payload, {
      idPrefix: "process",
      command: "进程执行"
    });
    return;
  }

  if (type === "process/exited") {
    completeProcessExecution(state, payload);
    return;
  }

  if (type === "item/fileChange/outputDelta" || type === "item/fileChange/patchUpdated") {
    upsertThreadItem(state, {
      id: payload.itemId,
      type: "fileChange",
      changes: payload.changes ?? payload.patch?.changes ?? [],
      status: "in_progress"
    }, { runId: state.runId, streaming: state.live });
    return;
  }

  if (type === "item/mcpToolCall/progress") {
    upsertThreadItem(state, {
      id: payload.itemId,
      type: "mcpToolCall",
      server: payload.server,
      tool: payload.tool,
      status: "in_progress",
      output: payload.message ? { progress: payload.message } : null
    }, { runId: state.runId, streaming: state.live });
    return;
  }

  if (type === "turn/plan/updated") {
    upsertPlan(state, payload);
    return;
  }

  if (type === "turn/diff/updated") {
    upsertDiff(state, payload);
    return;
  }

  if (type === "approval.requested") {
    upsertApproval(state, payload);
    return;
  }

  if (type === "approval.decided") {
    upsertApproval(state, {
      ...payload,
      runId: payload.runId ?? state.runId,
      status: "decided"
    });
    return;
  }

  if (type === "turn/failed" || type === "error") {
    appendError(state, payload.errorMessage ?? payload.message ?? "Codex 运行失败。", state.runId);
  }
}

function applyItemUpdate(state, payload) {
  const rawItem = payload.item ?? null;
  const itemType = canonicalType(rawItem?.type ?? payload.itemType);
  if (itemType === "agentMessage") {
    appendAssistantDelta(state, payload.delta ?? rawItem?.delta ?? rawItem?.text ?? "", rawItem?.id ?? payload.itemId ?? state.activeAssistantItemId);
    return;
  }
  if (itemType === "reasoning") {
    appendReasoningDelta(state, payload.delta ?? rawItem?.delta ?? "", rawItem?.id ?? payload.itemId ?? state.activeReasoningItemId);
    return;
  }
  if (itemType === "commandExecution") {
    appendCommandDelta(state, payload.delta ?? rawItem?.delta ?? rawItem?.aggregatedOutput ?? "", rawItem?.id ?? payload.itemId ?? state.activeCommandItemId, rawItem);
    return;
  }
  if (itemType === "fileChange" && rawItem) {
    upsertThreadItem(state, rawItem, { runId: state.runId, streaming: state.live });
    return;
  }
  if (itemType === "todoList" || itemType === "plan") {
    upsertPlan(state, rawItem);
    return;
  }
  if (rawItem) {
    upsertThreadItem(state, rawItem, { runId: state.runId, streaming: state.live });
  }
}

function upsertThreadItem(state, rawItem, meta = {}) {
  if (!rawItem || typeof rawItem !== "object") {
    return null;
  }
  const type = canonicalType(rawItem.type);
  const id = String(rawItem.id ?? `${state.runId}:${type}:${state.items.length}`);
  const existing = state.byId.get(id);
  const normalized = normalizeThreadItem(rawItem, {
    ...meta,
    id,
    type,
    existing
  });
  if (!normalized) {
    return null;
  }
  upsertDisplayItem(state, normalized);
  return normalized;
}

function normalizeThreadItem(rawItem, meta) {
  const type = meta.type;
  if (type === "userMessage") {
    return {
      id: meta.id,
      kind: "message",
      role: "user",
      text: stripSkybridgeContext(userContentText(rawItem.content)),
      attachments: meta.attachments ?? [],
      runId: meta.runId
    };
  }
  if (type === "agentMessage") {
    const text = String(rawItem.text ?? meta.existing?.text ?? "");
    return {
      id: meta.id,
      kind: "message",
      role: "assistant",
      text,
      phase: rawItem.phase ?? null,
      memoryCitation: rawItem.memoryCitation ?? rawItem.memory_citation ?? null,
      streaming: Boolean(meta.streaming && !text),
      runId: meta.runId
    };
  }
  if (type === "reasoning") {
    const status = meta.statusHint ?? rawItem.status ?? "completed";
    return {
      id: meta.id,
      kind: "reasoning",
      status,
      summary: toTextList(rawItem.summary),
      content: toTextList(rawItem.content),
      visible: isInProgressStatus(status),
      runId: meta.runId
    };
  }
  if (type === "commandExecution") {
    return {
      id: meta.id,
      kind: "command",
      command: rawItem.command ?? meta.existing?.command ?? "命令执行",
      cwd: rawItem.cwd ?? meta.existing?.cwd ?? "",
      output: rawItem.aggregatedOutput ?? rawItem.aggregated_output ?? meta.existing?.output ?? "",
      status: rawItem.status ?? meta.statusHint ?? meta.existing?.status ?? "in_progress",
      exitCode: rawItem.exitCode ?? rawItem.exit_code ?? null,
      durationMs: rawItem.durationMs ?? rawItem.duration_ms ?? null,
      runId: meta.runId
    };
  }
  if (type === "fileChange") {
    return {
      id: meta.id,
      kind: "fileChange",
      changes: normalizeChanges(rawItem.changes),
      status: rawItem.status ?? meta.statusHint ?? "completed",
      runId: meta.runId
    };
  }
  if (type === "hookPrompt") {
    const text = hookPromptText(rawItem.fragments);
    const fragments = Array.isArray(rawItem.fragments) ? rawItem.fragments : [];
    const hookRunId = fragments.find((fragment) => fragment?.hookRunId || fragment?.hook_run_id)?.hookRunId
      ?? fragments.find((fragment) => fragment?.hookRunId || fragment?.hook_run_id)?.hook_run_id
      ?? null;
    return {
      id: meta.id,
      kind: "hook",
      title: "Hook 提示",
      text,
      fragments,
      hookRunId,
      runId: meta.runId
    };
  }
  if (type === "mcpToolCall" || type === "dynamicToolCall" || type === "collabAgentToolCall") {
    return {
      id: meta.id,
      kind: "tool",
      toolType: type,
      server: rawItem.server ?? rawItem.namespace ?? (type === "collabAgentToolCall" ? "协作代理" : ""),
      tool: rawItem.tool ?? "tool",
      status: rawItem.status ?? meta.statusHint ?? "in_progress",
      durationMs: rawItem.durationMs ?? rawItem.duration_ms ?? null,
      input: normalizeToolInput(rawItem, type),
      output: normalizeToolOutput(rawItem, type),
      error: rawItem.error?.message ?? rawItem.error ?? toolFailureText(rawItem),
      runId: meta.runId
    };
  }
  if (type === "subAgentActivity") {
    return {
      id: meta.id,
      kind: "subAgent",
      status: rawItem.kind ?? "started",
      agentThreadId: rawItem.agentThreadId ?? rawItem.agent_thread_id ?? "",
      agentPath: rawItem.agentPath ?? rawItem.agent_path ?? "",
      runId: meta.runId
    };
  }
  if (type === "webSearch") {
    return {
      id: meta.id,
      kind: "webSearch",
      query: rawItem.query ?? "",
      action: rawItem.action ?? null,
      runId: meta.runId
    };
  }
  if (type === "plan" || type === "todoList") {
    return normalizePlan(meta.id, rawItem, meta.runId);
  }
  if (type === "imageView" || type === "imageGeneration") {
    return {
      id: meta.id,
      kind: "asset",
      assetType: type,
      label: type === "imageView" ? "查看图片" : "生成图片",
      path: rawItem.path ?? rawItem.savedPath ?? rawItem.saved_path ?? rawItem.filePath ?? rawItem.file_path ?? "",
      url: rawItem.url ?? rawItem.imageUrl ?? rawItem.image_url ?? resultUrl(rawItem.result) ?? "",
      prompt: rawItem.revisedPrompt ?? rawItem.revised_prompt ?? rawItem.prompt ?? rawItem.input ?? "",
      result: rawItem.result ?? null,
      status: rawItem.status ?? "completed",
      runId: meta.runId
    };
  }
  if (type === "contextCompaction") {
    return {
      id: meta.id,
      kind: "notice",
      icon: "compress",
      text: "上下文已压缩",
      runId: meta.runId
    };
  }
  if (type === "enteredReviewMode" || type === "exitedReviewMode") {
    return {
      id: meta.id,
      kind: "notice",
      icon: "rate_review",
      text: type === "enteredReviewMode" ? reviewNoticeText(rawItem.review) : "已退出代码审查模式",
      runId: meta.runId
    };
  }
  if (type === "error") {
    return {
      id: meta.id,
      kind: "error",
      text: rawItem.message ?? "Codex 运行失败。",
      runId: meta.runId
    };
  }
  return null;
}

function upsertDisplayItem(state, item) {
  const index = state.items.findIndex((entry) => entry.id === item.id);
  if (index >= 0) {
    const next = { ...state.items[index], ...item };
    state.items.splice(index, 1, next);
    state.byId.set(item.id, next);
    return;
  }
  state.items.push(item);
  state.byId.set(item.id, item);
}

function appendAssistantDelta(state, delta, itemId) {
  const text = String(delta ?? "");
  if (!text) return;
  const id = String(itemId ?? state.activeAssistantItemId ?? state.assistantDeltaId);
  const existing = state.byId.get(id);
  upsertDisplayItem(state, {
    id,
    kind: "message",
    role: "assistant",
    text: `${existing?.text ?? ""}${text}`,
    streaming: state.live,
    runId: state.runId
  });
}

function appendReasoningDelta(state, delta, itemId, target = "content") {
  const id = String(itemId ?? state.activeReasoningItemId ?? `${state.runId}:reasoning`);
  const existing = state.byId.get(id);
  const text = String(delta ?? "");
  const status = fallbackActivityStatus(state, existing);
  upsertDisplayItem(state, {
    id,
    kind: "reasoning",
    status,
    summary: target === "summary" ? [...(existing?.summary ?? []), text].filter(Boolean) : existing?.summary ?? [],
    content: target === "content" ? [...(existing?.content ?? []), text].filter(Boolean) : existing?.content ?? [],
    visible: isInProgressStatus(status),
    runId: state.runId
  });
}

function appendPlanDelta(state, payload) {
  const id = String(payload?.itemId ?? payload?.id ?? `${state.runId}:plan-stream`);
  const existing = state.byId.get(id);
  const text = `${existing?.text ?? ""}${String(payload?.delta ?? "")}`;
  if (!text) return;
  upsertDisplayItem(state, {
    id,
    kind: "plan",
    text,
    explanation: "",
    steps: [],
    runId: state.runId
  });
}

function appendCommandDelta(state, delta, itemId, rawItem = {}) {
  const id = String(itemId ?? state.activeCommandItemId ?? `${state.runId}:command:${state.commandDeltaIds.size}`);
  const existing = state.byId.get(id);
  const status = rawItem.status ?? existing?.status ?? fallbackActivityStatus(state, existing);
  upsertDisplayItem(state, {
    id,
    kind: "command",
    command: rawItem.command ?? existing?.command ?? "命令执行",
    cwd: rawItem.cwd ?? existing?.cwd ?? "",
    output: `${existing?.output ?? ""}${String(delta ?? "")}`,
    status,
    exitCode: rawItem.exitCode ?? rawItem.exit_code ?? existing?.exitCode ?? null,
    durationMs: rawItem.durationMs ?? rawItem.duration_ms ?? existing?.durationMs ?? null,
    runId: state.runId
  });
}

function appendCommandTerminalInteraction(state, payload) {
  const stdin = String(payload?.stdin ?? "");
  if (!stdin) return;
  const itemId = payload?.itemId ?? state.activeCommandItemId;
  const existing = itemId ? state.byId.get(String(itemId)) : null;
  const separator = existing?.output && !String(existing.output).endsWith("\n") ? "\n" : "";
  const inputLine = `${separator}输入：${stdin.trimEnd()}\n`;
  appendCommandDelta(state, inputLine, itemId, {
    command: existing?.command ?? "终端交互",
    status: existing?.status ?? fallbackActivityStatus(state, existing)
  });
}

function appendProcessOutputDelta(state, payload, options) {
  const processId = String(payload?.processId ?? payload?.processHandle ?? payload?.itemId ?? `${options.idPrefix}:unknown`);
  const id = `${state.runId}:${options.idPrefix}:${processId}`;
  const existing = state.byId.get(id);
  const stream = payload?.stream ?? "stdout";
  const delta = String(payload?.delta ?? decodeBase64Text(payload?.deltaBase64));
  const capReached = Boolean(payload?.capReached);
  const capState = { ...(existing?.capReached ?? {}) };
  const capNote = capReached && !capState[stream] ? `${streamLabel(stream)}输出已截断。\n` : "";
  if (capReached) {
    capState[stream] = true;
  }
  upsertDisplayItem(state, {
    id,
    kind: "command",
    command: existing?.command ?? options.command,
    cwd: existing?.cwd ?? "",
    output: `${existing?.output ?? ""}${delta}${capNote}`,
    status: existing?.status ?? fallbackActivityStatus(state, existing),
    exitCode: existing?.exitCode ?? null,
    durationMs: existing?.durationMs ?? null,
    processId,
    capReached: capState,
    runId: state.runId
  });
}

function completeProcessExecution(state, payload) {
  const processId = String(payload?.processHandle ?? payload?.processId ?? "unknown");
  const id = `${state.runId}:process:${processId}`;
  const existing = state.byId.get(id);
  const stdout = String(payload?.stdout ?? "");
  const stderr = String(payload?.stderr ?? "");
  const exitCode = Number(payload?.exitCode ?? 0);
  const capReached = {
    ...(existing?.capReached ?? {}),
    ...(payload?.stdoutCapReached ? { stdout: true } : {}),
    ...(payload?.stderrCapReached ? { stderr: true } : {})
  };
  const capNote = processExitCapNote(payload, existing);
  upsertDisplayItem(state, {
    id,
    kind: "command",
    command: existing?.command ?? "进程执行",
    cwd: existing?.cwd ?? "",
    output: `${existing?.output ?? ""}${stdout}${stderr}${capNote}`,
    status: exitCode === 0 ? "completed" : "failed",
    exitCode,
    durationMs: existing?.durationMs ?? null,
    processId,
    capReached,
    runId: state.runId
  });
}

function processExitCapNote(payload, existing) {
  const notes = [];
  if (payload?.stdoutCapReached && !existing?.capReached?.stdout) {
    notes.push("stdout 输出已截断。");
  }
  if (payload?.stderrCapReached && !existing?.capReached?.stderr) {
    notes.push("stderr 输出已截断。");
  }
  return notes.length ? `${notes.join("\n")}\n` : "";
}

function streamLabel(stream) {
  return stream === "stderr" ? "stderr " : stream === "stdout" ? "stdout " : "";
}

function setActiveDeltaTarget(state, item) {
  if (!item?.id) return;
  if (item.kind === "message" && item.role === "assistant") {
    state.activeAssistantItemId = item.id;
    return;
  }
  if (item.kind === "reasoning") {
    state.activeReasoningItemId = item.id;
    return;
  }
  if (item.kind === "command") {
    state.activeCommandItemId = item.id;
  }
}

function clearActiveDeltaTarget(state, item) {
  if (!item?.id) return;
  if (state.activeAssistantItemId === item.id) {
    state.activeAssistantItemId = null;
  }
  if (state.activeReasoningItemId === item.id) {
    state.activeReasoningItemId = null;
  }
  if (state.activeCommandItemId === item.id) {
    state.activeCommandItemId = null;
  }
}

function upsertPlan(state, payload) {
  const item = normalizePlan(payload?.id ?? state.planId, payload, state.runId);
  if (item) {
    upsertDisplayItem(state, item);
  }
}

function upsertNotice(state, notice) {
  upsertDisplayItem(state, {
    id: String(notice.id),
    kind: "notice",
    icon: notice.icon ?? "info",
    text: notice.text,
    runId: state.runId
  });
}

function upsertContextCompactionNotice(state, payload) {
  upsertNotice(state, {
    id: String(payload?.itemId ?? `${state.runId}:context-compacted`),
    icon: "compress",
    text: "上下文已压缩"
  });
}

function upsertThreadGoalNotice(state, payload) {
  const goal = payload?.goal ?? {};
  const status = goalStatusLabel(goal.status);
  const objective = truncateInline(goal.objective, 88);
  upsertNotice(state, {
    id: `${state.runId}:thread-goal:${payload?.threadId ?? goal.threadId ?? "current"}`,
    icon: goal.status === "complete" ? "task_alt" : goal.status === "blocked" ? "report" : "flag",
    text: objective ? `目标${status ? `（${status}）` : ""}：${objective}` : `目标${status ? `（${status}）` : ""}已更新。`
  });
}

function upsertModelRerouteNotice(state, payload) {
  const fromModel = String(payload?.fromModel ?? "").trim();
  const toModel = String(payload?.toModel ?? "").trim();
  const reason = modelRerouteReasonLabel(payload?.reason);
  upsertNotice(state, {
    id: `${state.runId}:model-rerouted:${payload?.turnId ?? "current"}`,
    icon: "model_training",
    text: `模型已切换${fromModel || toModel ? `：${[fromModel, toModel].filter(Boolean).join(" → ")}` : ""}${reason ? `（${reason}）` : ""}。`
  });
}

function upsertModelVerificationNotice(state, payload) {
  const verifications = Array.isArray(payload?.verifications) ? payload.verifications : [];
  if (!verifications.length) return;
  upsertNotice(state, {
    id: `${state.runId}:model-verification:${payload?.turnId ?? "current"}`,
    icon: "verified",
    text: `模型权限已验证：${verifications.map(modelVerificationLabel).join("、")}。`
  });
}

function upsertAccountLoginNotice(state, payload) {
  if (payload?.success === false) {
    upsertDisplayItem(state, {
      id: `${state.runId}:account-login:${payload?.loginId ?? "current"}`,
      kind: "error",
      text: `账号登录失败${payload?.error ? `：${humanError(payload.error)}` : "。"}`,
      runId: state.runId
    });
    return;
  }
  upsertNotice(state, {
    id: `${state.runId}:account-login:${payload?.loginId ?? "current"}`,
    icon: "account_circle",
    text: "账号登录已完成。"
  });
}

function upsertMcpOauthNotice(state, payload) {
  const name = String(payload?.name ?? "MCP 服务").trim() || "MCP 服务";
  if (payload?.success === false) {
    upsertDisplayItem(state, {
      id: `${state.runId}:mcp-oauth:${name}`,
      kind: "error",
      text: `${name} 登录失败${payload?.error ? `：${humanError(payload.error)}` : "。"}`,
      runId: state.runId
    });
    return;
  }
  upsertNotice(state, {
    id: `${state.runId}:mcp-oauth:${name}`,
    icon: "verified_user",
    text: `${name} 已完成登录。`
  });
}

function upsertWindowsWorldWritableWarning(state, payload) {
  const samplePaths = Array.isArray(payload?.samplePaths) ? payload.samplePaths.map(String).filter(Boolean) : [];
  const pathText = samplePaths.slice(0, 2).join("、");
  const extraCount = Number(payload?.extraCount ?? 0);
  const suffix = [
    pathText ? `示例：${pathText}` : "",
    extraCount > 0 ? `另有 ${extraCount} 个路径` : "",
    payload?.failedScan ? "扫描未完全完成" : ""
  ].filter(Boolean).join("；");
  upsertDisplayItem(state, {
    id: `${state.runId}:windows-world-writable-warning`,
    kind: "error",
    text: `检测到 Windows 可被所有用户写入的路径${suffix ? `（${suffix}）` : ""}。`,
    runId: state.runId
  });
}

function upsertWindowsSandboxSetupNotice(state, payload) {
  const mode = windowsSandboxModeLabel(payload?.mode);
  if (payload?.success === false) {
    upsertDisplayItem(state, {
      id: `${state.runId}:windows-sandbox-setup`,
      kind: "error",
      text: `${mode}准备失败${payload?.error ? `：${humanError(payload.error)}` : "。"}`,
      runId: state.runId
    });
    return;
  }
  upsertNotice(state, {
    id: `${state.runId}:windows-sandbox-setup`,
    icon: "shield",
    text: `${mode}准备完成。`
  });
}

function windowsSandboxModeLabel(mode) {
  const labels = {
    elevated: "Windows 管理员沙箱",
    unelevated: "Windows 普通权限沙箱"
  };
  return labels[mode] ?? "Windows 沙箱";
}

function goalStatusLabel(status) {
  const labels = {
    active: "进行中",
    paused: "已暂停",
    blocked: "已阻塞",
    usageLimited: "用量受限",
    budgetLimited: "预算受限",
    complete: "已完成"
  };
  return labels[status] ?? "";
}

function modelRerouteReasonLabel(reason) {
  const labels = {
    highRiskCyberActivity: "高风险网络安全活动"
  };
  return labels[reason] ?? "";
}

function modelVerificationLabel(value) {
  const labels = {
    trustedAccessForCyber: "网络安全可信访问"
  };
  return labels[value] ?? String(value ?? "");
}

function upsertHookRun(state, payload, statusHint) {
  const run = payload?.run ?? {};
  const hookRunId = String(run.id ?? payload?.hookRunId ?? payload?.hook_run_id ?? `${state.runId}:hook`);
  const existing = state.byId.get(`${state.runId}:hook-run:${hookRunId}`);
  const entries = Array.isArray(run.entries) ? run.entries : existing?.entries ?? [];
  upsertDisplayItem(state, {
    id: `${state.runId}:hook-run:${hookRunId}`,
    kind: "hook",
    title: hookRunTitle(run.eventName ?? existing?.eventName),
    text: hookRunText(run, entries, existing),
    hookRunId,
    eventName: run.eventName ?? existing?.eventName ?? "",
    handlerType: run.handlerType ?? existing?.handlerType ?? "",
    source: run.source ?? existing?.source ?? "",
    sourcePath: run.sourcePath ?? existing?.sourcePath ?? "",
    status: run.status ?? statusHint,
    statusMessage: run.statusMessage ?? existing?.statusMessage ?? "",
    durationMs: run.durationMs ?? existing?.durationMs ?? null,
    entries,
    runId: state.runId
  });
}

function upsertAutoApprovalReview(state, payload, status) {
  const reviewId = String(payload?.reviewId ?? payload?.review_id ?? `${state.runId}:auto-review`);
  const existing = state.byId.get(`${state.runId}:auto-review:${reviewId}`);
  const review = payload?.review ?? existing?.review ?? {};
  const action = payload?.action ?? existing?.action ?? {};
  upsertDisplayItem(state, {
    id: `${state.runId}:auto-review:${reviewId}`,
    kind: "autoReview",
    reviewId,
    status: review.status ?? status,
    riskLevel: review.riskLevel ?? review.risk_level ?? existing?.riskLevel ?? null,
    userAuthorization: review.userAuthorization ?? review.user_authorization ?? existing?.userAuthorization ?? null,
    rationale: review.rationale ?? existing?.rationale ?? "",
    targetItemId: payload?.targetItemId ?? payload?.target_item_id ?? existing?.targetItemId ?? null,
    decisionSource: payload?.decisionSource ?? payload?.decision_source ?? existing?.decisionSource ?? null,
    action,
    actionLabel: approvalReviewActionLabel(action),
    review,
    runId: state.runId
  });
}

function upsertDiff(state, payload) {
  const diff = String(payload?.diff ?? payload?.unifiedDiff ?? payload?.unified_diff ?? "");
  if (!diff.trim()) {
    return;
  }
  const parsed = parseUnifiedDiff(diff);
  upsertDisplayItem(state, {
    id: String(payload?.id ?? state.diffId),
    kind: "diff",
    diff,
    lines: diff.split(/\r?\n/),
    files: parsed.files,
    additions: parsed.additions,
    deletions: parsed.deletions,
    runId: state.runId
  });
}

function normalizePlan(id, payload, runId) {
  const rawSteps = payload?.plan ?? payload?.items ?? [];
  const text = String(payload?.text ?? "").trim();
  if ((!Array.isArray(rawSteps) || rawSteps.length === 0) && !text) {
    return null;
  }
  return {
    id: String(id),
    kind: "plan",
    text,
    explanation: payload.explanation ?? "",
    steps: Array.isArray(rawSteps) ? rawSteps.map((step, index) => ({
      id: step.id ?? `${id}:${index}`,
      text: step.text ?? step.step ?? "",
      status: step.status ?? (step.completed ? "completed" : "pending")
    })) : [],
    runId
  };
}

function normalizeToolInput(rawItem, type) {
  const value = rawItem.input ?? rawItem.arguments ?? rawItem.args ?? rawItem.params ?? null;
  if (type !== "collabAgentToolCall") {
    return value;
  }
  return compactObject({
    prompt: rawItem.prompt ?? null,
    model: rawItem.model ?? null,
    reasoningEffort: rawItem.reasoningEffort ?? rawItem.reasoning_effort ?? null,
    senderThreadId: rawItem.senderThreadId ?? rawItem.sender_thread_id ?? null,
    receiverThreadIds: rawItem.receiverThreadIds ?? rawItem.receiver_thread_ids ?? null
  });
}

function approvalReviewActionLabel(action) {
  const type = String(action?.type ?? "");
  if (type === "command") return compactLabel("命令", action.command);
  if (type === "execve") return compactLabel("程序", [action.program, ...(action.argv ?? [])].filter(Boolean).join(" "));
  if (type === "applyPatch") return `文件修改 · ${(action.files ?? []).length || 1} 个文件`;
  if (type === "networkAccess") return compactLabel("网络访问", [action.host, action.port].filter(Boolean).join(":"));
  if (type === "mcpToolCall") return compactLabel("MCP 工具", [action.server, action.toolTitle ?? action.toolName].filter(Boolean).join(" / "));
  if (type === "requestPermissions") return compactLabel("权限请求", action.reason);
  return "审批审查";
}

function compactLabel(prefix, value) {
  const text = String(value ?? "").trim();
  if (!text) return prefix;
  return `${prefix} · ${text}`;
}

function truncateInline(value, limit) {
  const text = String(value ?? "").replace(/\s+/g, " ").trim();
  if (!text || text.length <= limit) return text;
  return `${text.slice(0, Math.max(0, limit - 3)).trim()}...`;
}

function normalizeToolOutput(rawItem, type) {
  const value = rawItem.output ?? rawItem.result ?? rawItem.response ?? null;
  if (value !== null && value !== undefined) {
    return value;
  }
  if (type === "dynamicToolCall") {
    return rawItem.contentItems ?? rawItem.content_items ?? null;
  }
  if (type === "collabAgentToolCall") {
    return compactObject({
      receiverThreadIds: rawItem.receiverThreadIds ?? rawItem.receiver_thread_ids ?? null,
      agentsStates: rawItem.agentsStates ?? rawItem.agents_states ?? null
    });
  }
  return null;
}

function toolFailureText(rawItem) {
  if (rawItem.success === false) {
    return "工具调用未成功。";
  }
  return "";
}

function hookPromptText(fragments) {
  if (!Array.isArray(fragments)) {
    return "";
  }
  return fragments.map((fragment) => fragment?.text ?? "").filter(Boolean).join("\n").trim();
}

function hookRunTitle(eventName) {
  const labels = {
    preToolUse: "工具调用前 Hook",
    permissionRequest: "权限请求 Hook",
    postToolUse: "工具调用后 Hook",
    preCompact: "压缩前 Hook",
    postCompact: "压缩后 Hook",
    sessionStart: "会话启动 Hook",
    userPromptSubmit: "消息提交 Hook",
    subagentStart: "子任务启动 Hook",
    subagentStop: "子任务结束 Hook",
    stop: "停止 Hook"
  };
  return labels[eventName] ?? "Hook 运行";
}

function hookRunText(run, entries, existing) {
  const message = String(run?.statusMessage ?? existing?.statusMessage ?? "").trim();
  if (message) return message;
  const output = hookOutputText(entries);
  if (output) return output;
  const path = String(run?.sourcePath ?? existing?.sourcePath ?? "").trim();
  if (path) return path;
  return "Codex 正在处理扩展 Hook";
}

function hookOutputText(entries) {
  if (!Array.isArray(entries)) return "";
  return entries
    .filter((entry) => ["context", "warning", "error", "feedback", "stop"].includes(entry?.kind))
    .map((entry) => String(entry?.text ?? "").trim())
    .filter(Boolean)
    .join("\n")
    .trim();
}

function decodeBase64Text(value) {
  const base64 = String(value ?? "");
  if (!base64) return "";
  try {
    if (globalThis.Buffer) {
      return globalThis.Buffer.from(base64, "base64").toString("utf8");
    }
    const binary = globalThis.atob(base64);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder().decode(bytes);
  } catch {
    return "";
  }
}

function resultUrl(result) {
  const value = String(result ?? "").trim();
  if (/^https?:\/\//i.test(value) || /^data:image\//i.test(value)) {
    return value;
  }
  return "";
}

function compactObject(value) {
  const entries = Object.entries(value ?? {}).filter(([, entry]) => {
    if (entry === null || entry === undefined || entry === "") return false;
    if (Array.isArray(entry) && entry.length === 0) return false;
    if (typeof entry === "object" && !Array.isArray(entry) && Object.keys(entry).length === 0) return false;
    return true;
  });
  return entries.length ? Object.fromEntries(entries) : null;
}

function appendRunArtifacts(state, artifacts) {
  if (!Array.isArray(artifacts) || artifacts.length === 0) {
    return;
  }
  artifacts.forEach((artifact, index) => {
    if (!artifact || typeof artifact !== "object" || Array.isArray(artifact)) {
      return;
    }
    const artifactId = String(artifact.artifactId ?? artifact.objectKey ?? index);
    const objectKey = String(artifact.objectKey ?? "");
    if (!objectKey) {
      return;
    }
    upsertDisplayItem(state, {
      id: `${state.runId}:artifact:${artifactId}`,
      kind: "asset",
      assetType: "artifact",
      label: "生成文件",
      name: String(artifact.name ?? artifact.relativePath ?? "生成文件"),
      path: String(artifact.relativePath ?? artifact.path ?? ""),
      objectKey,
      sha256: artifact.sha256 ?? "",
      size: Number(artifact.size ?? 0),
      contentType: artifact.contentType ?? "application/octet-stream",
      createdAt: artifact.createdAt ?? null,
      status: "completed",
      runId: state.runId
    });
  });
}

function upsertApproval(state, approval) {
  if (!approval?.approvalId) {
    return;
  }
  const runId = approval.runId ?? state.runId;
  const existingIndex = state.items.findIndex((item) => item.kind === "approval" && item.runId === runId && item.approvalId === approval.approvalId);
  const existing = existingIndex >= 0 ? state.items[existingIndex] : null;
  const mergedApproval = {
    ...(existing?.approval ?? {}),
    ...approval,
    runId
  };
  const item = {
    id: existing?.id ?? `${runId}:approval:${approval.approvalId}`,
    kind: "approval",
    runId,
    approvalId: approval.approvalId,
    approval: mergedApproval,
    status: mergedApproval.decision ? "decided" : mergedApproval.status ?? "pending"
  };
  state.approvalIds.add(approval.approvalId);
  if (existingIndex >= 0) {
    state.items.splice(existingIndex, 1, item);
  } else {
    state.items.push(item);
  }
}

function appendApprovals(state, approvals) {
  for (const approval of approvals) {
    upsertApproval(state, approval);
  }
}

function appendRunError(state, run, events) {
  if (run?.status !== "failed") {
    return;
  }
  const hasError = state.items.some((item) => item.kind === "error");
  if (hasError) {
    return;
  }
  const failedEvent = [...events].reverse().find((event) => {
    const type = normalizeEventType(event.type);
    return type === "turn/failed" || type === "error";
  });
  const message = failedEvent?.payload?.errorMessage ?? failedEvent?.payload?.message ?? run.errorMessage ?? "Codex 运行失败。";
  appendError(state, message, state.runId);
}

function appendRunStatusNotice(state, run) {
  const status = String(run?.status ?? "");
  const notice = RUN_STATUS_NOTICES[status];
  if (!notice) {
    return;
  }
  if (state.items.some((item) => item.id === `${state.runId}:status:${status}`)) {
    return;
  }
  state.items.push({
    id: `${state.runId}:status:${status}`,
    kind: "notice",
    icon: notice.icon,
    text: notice.text,
    runId: state.runId
  });
}

function appendError(state, message, runId) {
  const text = humanError(message);
  if (!text) return;
  const id = `${runId}:error:${state.items.length}`;
  state.items.push({ id, kind: "error", text, runId });
}

function ensureOptimisticUserMessage(state, detail) {
  const hasUser = state.items.some((item) => item.kind === "message" && item.role === "user");
  if (hasUser || !detail.optimisticPrompt) {
    return;
  }
  state.items.unshift({
    id: `${state.runId}:optimistic-user`,
    kind: "message",
    role: "user",
    text: detail.optimisticPrompt,
    attachments: detail.optimisticAttachments ?? [],
    runId: state.runId
  });
}

function ensureFallbackAssistantMessage(state, detail) {
  const hasAssistant = state.items.some((item) => item.kind === "message" && item.role === "assistant" && item.text);
  if (hasAssistant) {
    return;
  }
  const events = detail.events ?? [];
  const finalMessage = [...events].reverse().find((event) => normalizeEventType(event.type) === "turn/completed" && event.payload?.finalMessage)?.payload?.finalMessage;
  if (finalMessage) {
    state.items.push({
      id: `${state.runId}:assistant-final`,
      kind: "message",
      role: "assistant",
      text: humanError(finalMessage),
      streaming: false,
      runId: state.runId
    });
  }
}

function isItemStarted(type) {
  return type === "item/started";
}

function isItemCompleted(type) {
  return type === "item/completed";
}

function terminalStatus(rawItem) {
  const status = rawItem?.status;
  if (status) return status;
  return "completed";
}

function canonicalType(type) {
  const raw = String(type ?? "");
  return TYPE_ALIASES[raw] ?? raw;
}

function normalizeEventType(type) {
  const raw = String(type ?? "");
  return EVENT_TYPE_ALIASES[raw] ?? raw;
}

function fallbackActivityStatus(state, existing) {
  if (existing?.status && !isInProgressStatus(existing.status)) {
    return existing.status;
  }
  if (state.live) {
    return "in_progress";
  }
  if (state.run?.status === "failed") {
    return "failed";
  }
  return "completed";
}

function isInProgressStatus(status) {
  return status === "in_progress" || status === "inProgress";
}

function userContentText(content) {
  if (!Array.isArray(content)) {
    return String(content?.text ?? "");
  }
  return content
    .map((entry) => entry?.text ?? entry?.inputText ?? entry?.input_text ?? "")
    .filter(Boolean)
    .join("\n")
    .trim();
}

function itemAttachments(rawItem) {
  const content = rawItem?.content;
  if (!Array.isArray(content)) {
    return [];
  }
  return content
    .filter((entry) => {
      const type = canonicalType(entry?.type);
      return type.includes("image") || type.includes("file") || entry?.path || entry?.url;
    })
    .map((entry, index) => ({
      fileId: entry.fileId ?? entry.id ?? `${rawItem.id}:attachment:${index}`,
      name: entry.name ?? entry.path ?? entry.url ?? `附件 ${index + 1}`,
      path: entry.path,
      url: entry.url
    }));
}

function normalizeChanges(changes) {
  if (!Array.isArray(changes)) return [];
  return changes.map((change, index) => ({
    id: change.id ?? `${change.path ?? "file"}:${index}`,
    path: change.path ?? change.file ?? change.movePath ?? change.move_path ?? "未知文件",
    kind: change.kind ?? change.type ?? "update"
  }));
}

function parseUnifiedDiff(diff) {
  const files = [];
  let current = null;
  for (const line of String(diff ?? "").split(/\r?\n/)) {
    if (line.startsWith("diff --git ")) {
      current = {
        id: `diff:${files.length}`,
        path: diffGitPath(line) ?? "未知文件",
        additions: 0,
        deletions: 0
      };
      files.push(current);
      continue;
    }
    if (!current && (line.startsWith("--- ") || line.startsWith("+++ "))) {
      current = {
        id: `diff:${files.length}`,
        path: cleanDiffPath(line.slice(4)) ?? "未知文件",
        additions: 0,
        deletions: 0
      };
      files.push(current);
    }
    if (current && line.startsWith("+++ ")) {
      current.path = cleanDiffPath(line.slice(4)) ?? current.path;
      continue;
    }
    if (current && line.startsWith("rename to ")) {
      current.path = line.slice("rename to ".length).trim() || current.path;
      continue;
    }
    if (current && line.startsWith("+") && !line.startsWith("+++")) {
      current.additions += 1;
      continue;
    }
    if (current && line.startsWith("-") && !line.startsWith("---")) {
      current.deletions += 1;
    }
  }
  return {
    files,
    additions: files.reduce((sum, file) => sum + file.additions, 0),
    deletions: files.reduce((sum, file) => sum + file.deletions, 0)
  };
}

function diffGitPath(line) {
  const match = String(line ?? "").match(/^diff --git a\/(.+?) b\/(.+)$/);
  return cleanDiffPath(match?.[2] ?? match?.[1]);
}

function cleanDiffPath(value) {
  const text = String(value ?? "").trim();
  if (!text || text === "/dev/null") return null;
  return text.replace(/^[ab]\//, "");
}

function toTextList(value) {
  if (Array.isArray(value)) {
    return value.map((entry) => String(entry?.text ?? entry ?? "")).filter(Boolean);
  }
  return String(value ?? "") ? [String(value)] : [];
}

function humanError(value) {
  const text = String(value ?? "").trim();
  if (!text) return "";
  if (!text.startsWith("{")) return text;
  try {
    const parsed = JSON.parse(text);
    return parsed.error?.message ?? parsed.message ?? parsed.error ?? text;
  } catch {
    return text;
  }
}

function reviewNoticeText(value) {
  const review = String(value ?? "").trim();
  return review ? `已进入代码审查模式 · ${review}` : "已进入代码审查模式";
}

function stripSkybridgeContext(value) {
  const text = String(value ?? "");
  const markers = [
    "\n\nSkybridge file references:",
    "\n\nSkybridge slash command:",
    "\n\nAttached files materialized on the Mac listener:",
    "\n\nAttached file references materialized on the Mac listener:"
  ];
  let end = text.length;
  for (const marker of markers) {
    const index = text.indexOf(marker);
    if (index >= 0) {
      end = Math.min(end, index);
    }
  }
  return text.slice(0, end).trim();
}

function cryptoRandomFallback() {
  return `run:${Math.random().toString(36).slice(2)}`;
}
